// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"699e30d2","163":"df6b7c3a","631":"37970073","725":"6d66ad5f","882":"8813d2d5"}[chunkId] + ".chunk.js";
};